// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LMkg","type":"styles_type__34Yk6","choices":"styles_choices__1ls_4"};